// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"691":"component---src-pages-index-tsx","774":"framework","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"223":"92e8d9802fdfade5cbb0","231":"35d180c52a3a65770f82","691":"73fa8daddb969630977f","774":"d1d25cee0d680c48cbb8","883":"8841e3558ecb802150d3"}[chunkId] + ".js";
};